<template>
  <popup :opened="isDisplayed" @close="closePopup">
    <div class="mx-5 xl:mx-15 2xl:mx-20 my-8 w-auto h-auto">
      <h3 v-if="jobNotFound === false" class="mb-6 text-3xl font-normal">
        {{ libellePage }} : Ajouter
        {{ typeStructure == constants.TYPE_OF ? 'une formation' : 'un poste' }}
      </h3>
      <h3 v-else-if="jobNotFound === true" class="mb-6 text-3xl font-normal">
        {{ libellePage
        }}<span class="">
          :
          {{
            typeStructure == constants.TYPE_OF
              ? 'Référentiel de formation inexistant'
              : 'Fiche de poste inexistante'
          }}</span
        >
      </h3>
      <h6
        v-if="jobNotFound === false && descs.length > 0"
        class="text-indigo-600 mb-5"
      >
        Sélectionnez depuis
        {{
          $isGuest()
            ? 'la bibliothèque personnelles de ' + infosPass.name
            : 'votre bibliothèque personnelle'
        }},
        {{
          typeStructure == constants.TYPE_OF
            ? 'le référentiel de formation'
            : 'la fiche de poste'
        }}
        dont vous avez besoin pour débuter une évaluation.
      </h6>
      <h6
        v-else-if="jobNotFound === true"
        class="text-pink-600 mb-5 font-normal italic text-base w-3/4 m-auto"
      >
        Suite à une suppression,
        {{
          typeStructure == constants.TYPE_OF
            ? 'le référentiel de formation'
            : 'la fiche de poste'
        }}
        "{{ deletedDesc.name }}" ne fait plus partie de votre bibliothèque
        personnelle. <br /><span v-if="descs.length > 0"
          >Veuillez ajouter
          {{
            typeStructure == constants.TYPE_OF
              ? 'un nouveau référentiel de formation'
              : 'une nouvelle fiche de poste'
          }}
          à intégrer
          {{
            typeStructure == constants.TYPE_OF ? 'à la formation' : 'au poste'
          }}
          {{ job }}</span
        >
      </h6>

      <div v-show="descs.length > 0">
        <div
          class="relative flex flex-col justify-center items-center text-base font-normal text-gray-900"
        >
          <div class="w-full lg:w-1/3">
            <input-drop-down
              :options="descs"
              @selected="selectDesc"
              @noResult="noSearchResult = true"
              @foundResult="noSearchResult = false"
              :disabled="false"
              :name="
                typeStructure == constants.TYPE_OF
                  ? 'Référentiel de formation'
                  : 'Fiche de poste'
              "
              :max-item="10"
              :placeholder="
                'Saisir le nom ' +
                (typeStructure == constants.TYPE_OF
                  ? 'du référentiel de formation'
                  : 'de la fiche de poste')
              "
              ref="inputDropDownDescs"
              :libelle="
                typeStructure == constants.TYPE_OF
                  ? 'Référentiel de formation'
                  : 'Fiche de poste'
              "
            />
          </div>
          <p
            v-if="noSearchResult"
            class="cursor-default pt-3 pb-1 text-sm text-center text-pink-600 italic"
          >
            Si vous ne trouvez pas de
            {{
              typeStructure == constants.TYPE_OF
                ? 'référentiel de formation correspondant'
                : 'fiche de poste correspondante'
            }}
            à votre recherche, vous avez la possibilité de faire une recherche
            dans la
            <span>
              <router-link
                :to="{
                  name:
                    typeStructure == constants.TYPE_OF
                      ? 'ReferentielFormation'
                      : 'JobDescription',
                  params: { action: 'common' },
                }"
                class="text-indigo-600 underline"
              >
                bibliothèque commune
              </router-link>
            </span>
            pour voir si
            {{ typeStructure == constants.TYPE_OF ? 'il' : 'elle' }} existe, ou
            de {{ typeStructure == constants.TYPE_OF ? 'le' : 'la' }}
            <span>
              <router-link
                :to="{
                  name:
                    typeStructure == constants.TYPE_OF
                      ? 'ReferentielFormation'
                      : 'JobDescription',
                  params: { action: 'newDesc' },
                }"
                class="text-indigo-600 underline"
              >
                créer
              </router-link> </span
            >.
          </p>
        </div>
        <div v-if="true">
          <h5 class="my-5">OU</h5>
          <div class="flex flex-col justify-center w-full mb-5">
            <div
              class="grid grid-cols-4 w-full text-base font-normal text-gray-900 mb-2 gap-x-4"
            >
              <input-drop-down
                :options="types"
                @selected="selectTypeDesc"
                :disabled="false"
                :name="
                  'Type de ' +
                  (typeStructure == constants.TYPE_OF ? 'référentiel' : 'fiche')
                "
                :max-item="2"
                placeholder=""
                class="md:col-span-1"
                ref="inputDropDownType"
                :libelle="
                  'Type de ' +
                  (typeStructure == constants.TYPE_OF ? 'référentiel' : 'fiche')
                "
                :has-chevron="true"
              />
              <input-drop-down
                :options="sectors"
                @selected="selectSector"
                :disabled="false"
                name="Secteurs d'activité"
                :max-item="10"
                placeholder=""
                class="md:col-span-1"
                ref="inputDropDownSector"
                libelle="Secteur d'activité"
                :has-chevron="true"
              />
              <input-drop-down
                :options="families"
                @selected="selectFamily"
                :disabled="false"
                name="Famille professionnelle"
                :max-item="10"
                placeholder=""
                class="md:col-span-1"
                ref="inputDropDownFamily"
                libelle="Famille professionnelle"
                :has-chevron="true"
              />
              <input-drop-down
                :options="filteredDescs"
                @selected="advancedSearchSelectDesc"
                @noResult="noAdvancedSearchResult = true"
                @foundResult="noAdvancedSearchResult = false"
                :disabled="false"
                :name="
                  typeStructure == constants.TYPE_OF
                    ? 'Référentiels filtrés'
                    : 'Fiches de poste filtrées'
                "
                :max-item="10"
                placeholder=""
                class="md:col-span-1"
                ref="inputDropDownFilteredDescs"
                :libelle="
                  typeStructure == constants.TYPE_OF
                    ? 'Référentiel de formation'
                    : 'Fiche de poste'
                "
                :has-chevron="true"
              />
            </div>
            <p
              v-if="noAdvancedSearchResult"
              class="cursor-default pt-3 pb-1 text-sm text-center text-pink-600 italic"
            >
              Il n'y a pas de fiche de poste correspondante à votre recherche,
              vous avez la possibilité de faire une recherche dans la
              <span>
                <router-link
                  :to="{
                    name:
                      typeStructure == constants.TYPE_OF
                        ? 'ReferentielFormation'
                        : 'JobDescription',
                    params: { action: 'common' },
                  }"
                  class="text-indigo-600 underline"
                >
                  bibliothèque commune
                </router-link>
              </span>
              pour voir si elle existe, ou de la
              <span>
                <router-link
                  :to="{
                    name:
                      typeStructure == constants.TYPE_OF
                        ? 'ReferentielFormation'
                        : 'JobDescription',
                    params: { action: 'newDesc' },
                  }"
                  class="text-indigo-600 underline"
                >
                  créer
                </router-link> </span
              >.
            </p>
          </div>
        </div>
        <div class="w-max-content w-max mx-auto mt-10">
          <action-button
            :is-disabled="!selectedDesc.id"
            :right="true"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Continuer"
            :uppercase="true"
            icon="arrow-right_1"
            type-shadow="shadow-pink"
            @clickAction="
              selectedDesc.id ? $emit('selectJobDesc', selectedDesc) : null
            "
          />
        </div>
      </div>
      <div v-show="descs.length === 0">
        <h6 class="text-indigo-600 mb-8">
          <div>
            Il n'y a
            {{
              typeStructure == constants.TYPE_OF
                ? 'aucun référentiel de formation'
                : 'aucune fiche de poste'
            }}
            dans {{ $isGuest ? 'la' : 'votre' }} bibliothèque personnelle{{
              $isGuest ? ' de ' + infosPass.name : ''
            }}.
          </div>
          <div v-if="!$isGuest()">
            Vous avez la possibilité d'ajouter
            {{
              typeStructure == constants.TYPE_OF
                ? 'un référentiel de formation'
                : 'une fiche de poste'
            }}
            depuis la bibliothèque commune
            {{
              $freeParticulier()
                ? ''
                : ", ou d'en créer" +
                  (typeStructure === constants.TYPE_OF ? 'un' : 'une')
            }}.
          </div>
        </h6>

        <div class="w-full flex justify-center">
          <illustration name="no_result" class="w-full m-5" />
        </div>
        <div v-if="!$isGuest()" class="flex space-x-5 justify-center">
          <router-link
            :to="{
              name:
                typeStructure == constants.TYPE_OF
                  ? 'ReferentielFormation'
                  : 'JobDescription',
              params: { action: 'common' },
            }"
          >
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-indigo-600"
              bg-color-square="bg-indigo-600"
              icon-color="text-white"
              libelle="Ajouter depuis la bibliothèque commune"
              :uppercase="true"
              icon="plus-circle"
              :right="true"
              type-shadow="shadow-indigo"
              :enable-action="false"
            />
          </router-link>
          <router-link
            v-if="!$freeParticulier()"
            :to="{
              name:
                typeStructure == constants.TYPE_OF
                  ? 'ReferentielFormation'
                  : 'JobDescription',
              params: { action: 'newDesc' },
            }"
          >
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-indigo-600"
              bg-color-square="bg-indigo-600"
              icon-color="text-white"
              :libelle="
                'Créer ' +
                (typeStructure == constants.TYPE_OF
                  ? 'un nouveau référentiel de formation'
                  : 'une nouvelle fiche de poste')
              "
              icon="file-text"
              :right="true"
              :uppercase="true"
              type-shadow="shadow-indigo"
              :enable-action="false"
            />
          </router-link>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from './../../api';
import store from '../../store';

import Popup from '../Popup.vue';
import InputDropDown from './../../components/Inputs/InputDropDown.vue';
import ActionButton from '../ActionButton.vue';
import Illustration from '../Illustration.vue';

import Constants from './../../constants';

export default {
  components: {
    Popup,
    InputDropDown,
    ActionButton,
    Illustration,
  },

  props: {
    isDisplayed: {
      type: Boolean,
      required: true,
    },

    jobNotFound: {
      type: Boolean,
      required: true,
    },

    libellePage: {
      type: String,
      required: true,
    },

    deletedDesc: {
      //oldDesc which deleted in job desc personnal library
      type: Object,
      required: true,
    },

    numJob: {
      type: Number,
      required: true,
    },

    typeStructure: {
      type: String,
      required: false,
      default: Constants.TYPE_ESAT,
    },
  },

  data() {
    return {
      constants: Constants,

      noSearchResult: false,
      types: [],
      sectors: [],
      families: [],
      descs: [],
      selectedTypeDesc: '',
      selectedDesc: {},
      selectedSector: {},
      selectedFamily: {},
      filteredDescs: [],
      noAdvancedSearchResult: false,
    };
  },

  created() {
    // load all jobs desc to search and attribute one in "poste de travail"
    this.load_sectors();
    this.load_descs();
  },

  methods: {
    resetSearchFields() {
      this.$refs.inputDropDownType.searchFilter = '';
      this.$refs.inputDropDownDescs.searchFilter = '';
      this.$refs.inputDropDownSector.searchFilter = '';
      this.$refs.inputDropDownFamily.searchFilter = '';
      this.$refs.inputDropDownFilteredDescs.searchFilter = '';
    },

    closePopup() {
      this.$emit('close');
      this.selectedDesc = {};
      this.noSearchResult = false;
      this.noAdvancedSearchResult = false;
    },

    async load_sectors() {
      this.types = [];
      if (!(this.$freeParticulier() || this.$isGuest())) {
        this.types.push({
          name: 'Fiche Neopass',
          type: 'job_desc',
          id: 1,
          sectors: [],
        });
      }

      this.types.push({ name: 'Fiche ROME', type: 'rome', id: 2 });

      await axios
        .get('api/datatype/sectors')
        .then((response) => {
          let sectors = response.data.data;

          sectors.forEach(function (sector, sectorIndex) {
            sector.name = sector.value;
            sector.id = sectorIndex + 1;
            sector.families.forEach(function (family, familyIndex) {
              family.name = family.value;
              family.id = familyIndex + 1;
            });
          });

          let indexNeopassType = this.types.findIndex(
            (t) => t.type === 'job_desc'
          );

          //Only for neopass jobdesc
          if (indexNeopassType > -1) {
            this.types[indexNeopassType].sectors = sectors.map(
              (sector, index) => ({
                name: sector.value,
                id: index + 1,
                families: sector.families.map((family, jndex) => ({
                  name: family.value,
                  id: jndex + 1,
                })),
              })
            );
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });

      await axios
        .get('api/datatype/domaines')
        .then((response) => {
          if (response.data.data === undefined) {
            return;
          }

          let sectors = response.data.data;

          let indexRomeType = this.types.findIndex((t) => t.type === 'rome');

          //Only for neopass rome
          if (indexRomeType > -1) {
            this.types[indexRomeType].sectors = sectors.map(
              (sector, index) => ({
                name: sector.value,
                id: index + 1,
                families: sector.domaines.map((domaine, jndex) => ({
                  name: domaine.value,
                  id: jndex + 1,
                })),
              })
            );
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async load_descs() {
      store.commit('app/SET_LOADING', true);

      let typeDesc =
        this.typeStructure === Constants.TYPE_OF ? 'ref_formation' : 'job_desc';

      await axios
        .post(`/api/sheets/listByType/${typeDesc}`, {
          search: '',
          sector: '',
          family: '',
          wantEvaluationUsed: false,
        })
        .then((response) => {
          let datas = response.data;
          this.descs = datas.sheets;
          this.filteredDescs = JSON.parse(JSON.stringify(this.descs));
          store.commit('jobs/SET_JOBS_DESCS', this.descs);

          store.commit('app/SET_LOADING', false);
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response.data);
          store.commit('app/SET_LOADING', false);
        });
    },

    selectDesc(desc) {
      this.selectedDesc = desc;
      this.selectSector({});
      //This is to refresh the sectors array, triggering the options watcher in InputDropDown.vue, and purging the selected sector, family and desc from the inputs of the second row.
      this.sectors.push('');
      this.sectors.pop();
      this.families.push('');
      this.families.pop();
      this.filteredDescs.push('');
      this.filteredDescs.pop();
    },

    advancedSearchSelectDesc(desc) {
      this.selectedDesc = desc;
      this.noSearchResult = false;
      this.noAdvancedSearchResult = false;
      //This is to refresh the descs array, triggering the options watcher in InputDropDown.vue, and purging the selected desc on the very first input.
      this.descs.push('');
      this.descs.pop();
    },

    selectTypeDesc(type) {
      this.selectedTypeDesc = type;
      this.sectors = type.sectors ? type.sectors : [];
      this.selectedSector = {};

      if (!type.id) {
        this.filteredDescs = JSON.parse(JSON.stringify(this.descs));
      } else {
        this.filteredDescs = this.descs.filter(
          (desc) => desc.type === type.type
        );
      }
    },

    selectSector(sector) {
      this.selectedSector = sector;
      this.families = sector.families ? sector.families : [];
      this.selectedFamily = {};
      if (!sector.id) {
        this.filteredDescs = JSON.parse(JSON.stringify(this.descs));
      } else {
        this.filteredDescs = this.descs.filter(
          (desc) => desc.data.sector === sector.name
        );
      }
    },

    selectFamily(family) {
      this.selectedFamily = family;
      if (!family.id) {
      } else {
        this.filteredDescs = [];
        this.filteredDescs = this.descs.filter(
          (desc) => desc.data.family === family.name
        );
      }
    },
  },
  computed: {
    ...mapGetters({
      infosPass: 'neopass/infosPass',
    }),
  },
};
</script>
